export default __webpack_public_path__ + "static/media/36I-114281_-20909_0.5569dc27.jpg";